import React from 'react'
import styles from './styles.css'
import Loading from 'orionsoft-parts/lib/components/Loading'
import Paginated from 'meteor-paginated-graphql-react'
import MdDescription from 'react-icons/lib/md/developer-board'
import moment from 'moment'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import {withRouter} from 'react-router'
import Button from 'orionsoft-parts/lib/components/Button'

@withRouter
export default class Main extends React.Component {
  static propTypes = {
    router: PropTypes.object
  }

  getFields() {
    return [
      {title: '', name: '_id', render: () => <MdDescription />},
      {
        title: 'Nompre de Documento',
        name: 'preparationName'
      },
      {
        title: 'Nombres Cliente',
        name: 'clientNames'
      },
      {
        title: 'Email Cliente',
        name: 'clientEmail'
      },
      {
        title: 'Fecha',
        name: 'createdAt',
        render: ({date}) => moment(date).format('DD/MM/YYYY HH:mm')
      }
    ]
  }

  @autobind
  onSelect({_id}) {
    this.props.router.push(`/preparation/${_id}/documentinformation`)
  }

  render() {
    return (
      <div className={styles.container}>
        <div className="section">
          <div className="header">
            <h3 className={styles.title}>Documentos en preparación</h3>
          </div>
          <Paginated
            loadingComponent={Loading}
            queryName="ssPreparations"
            defaultLimit={25}
            fields={this.getFields()}
            params="$filter: String"
            onPress={this.onSelect}
          />
        </div>
        <Button primary onClick={() => this.props.router.push('/preparation/create')}>
          Preparar Documento
        </Button>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Custom/Main/index.js